import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProjectsEndpoints } from "../../Routes/api/Endpoints";
import { useProjectFilters } from "../../hook/useProjectFilters";
import { selectData } from "../../redux/features/userSliceWithTokenValidation";
import { useFetchCategoriesProjetsQuery } from "../../services/auth-services/AuthService";
import MonBouton from "../Utils/design-system/buttons/MonBouton";
import { ProjectsList } from "./ProjectList";
import { FilterButton, ServiceDropdown } from "./ServiceDropdown";
// import { staticData } from "../Utils/StaticDatas";
import { CiCircleChevLeft, CiCircleChevRight } from "react-icons/ci";
import { apiUrlImg } from "../../Routes/api/global_vars";
import { useFetchProjectsQuery } from "../../services/auth-services/TacheService";
// import ScrollableMenu from "../Utils/ScrollHorizont";

function CategoriesProjects({ display, contener }) {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const user = useSelector(selectData);
  const { data: categoriesProjets, isLoading } = useFetchCategoriesProjetsQuery(
    ProjectsEndpoints.categoriesProjets
  );
  // console.log(categoriesProjets);
  const [isScrollable, setIsScrollable] = useState(false);
  const scrollContainer = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  }

  useEffect(() => {
    const checkScroll = () => {
      if (scrollRef.current) {
        setIsScrollable(
          scrollRef.current.scrollWidth > scrollRef.current.clientWidth
        );
      }
    };
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);


  const {
    selectedCategory,
    selectedService,
    selectedSousService,
    showAllProjects,
    categoriesWithProjects,
    getSelectedServiceSousServices,
    getFilteredProjects,
    handleCategorySelect,
    handleServiceSelect,
    handleAllProjectsClick,
    handleSousServiceSelect,
    selectedServiceImg,
    getSelectedCategoryServices
  } = useProjectFilters(categoriesProjets);

  const filteredProjects = getFilteredProjects();
  return (
    <div className={`flex flex-col justify-center items-center  ${contener}`}>
      <div className="flex justify-center items-center flex-wrap w-[90%] ps-4 mb-8">
        <div className="flex flex-col space-y-4">
          <h1 className="text-4xl font-bold text-center text-noirel max-sm:text-lg max-lg:text-xl mb-0">
            Derniers projets sur le marché
          </h1>
          <p className="font-mandali font-normal text-base leading-6 text-center text-gris">
            Transformez vos compétences en revenus et gagnez <br />
            en expérience professionnelle !
          </p>
        </div>
      </div>
      <div className="flex justify-end w-[90%] pb-3">
        <div className="w-3/12 flex gap-2 justify-end text-gryborder">
          {isScrollable && (
            <button
              className=""
              onClick={() => scrollContainer("left")}
            >
              <CiCircleChevLeft className=" hover:text-orange active:text-orange" size={40} />
            </button>
          )}
          {isScrollable && (
            <button
              className=""
              onClick={() => scrollContainer("right")}
            >
              <CiCircleChevRight className=" hover:text-orange active:text-orange" size={40} />
            </button>
          )}
        </div>
      </div>

      <div className=" w-[90%] flex justify-center mb-6 ">

        <div
          className={`absolute z-20 w-[90%] mx-auto flex items-start gap-4 overflow-x-auto scrollbar-none ${categoriesWithProjects.length < 4 ? "justify-center" : ""
            }`}
          ref={scrollRef}
        >
          <FilterButton
            label="Tous les projets"
            onClick={handleAllProjectsClick}
            selected={showAllProjects}
          />
          <div className="flex w-max gap-4 pb-3">
            {categoriesWithProjects && categoriesWithProjects?.map((category) => (
              <ServiceDropdown
                key={category.id}
                category={category}
                selectedService={
                  selectedCategory?.id === category.id ? selectedService : null
                }
                selectedServiceImg={selectedServiceImg}
                onServiceSelect={(service) => {
                  handleCategorySelect(category);
                  handleServiceSelect(service);
                }}
                isActive={selectedCategory?.id === category.id}
              />
            ))}
          </div>
        </div>
      </div>

      {selectedCategory && selectedService && (
        <div className="w-[90%] mt-12 flex flex-col items-center font-inter font-medium">
          <h2 className="text-sm font-medium mb-3">Services</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {getSelectedCategoryServices()?.map((service, index) => {
              // Tableau de dégradés avec différentes couleurs et opacité augmentée
              const gradients = [
                'linear-gradient(135deg, rgba(0, 200, 150, 0.3), rgba(0, 200, 150, 0.1))',    // Vert plus vif
                'linear-gradient(135deg, rgba(255, 159, 67, 0.3), rgba(255, 159, 67, 0.1))',  // Orange
                'linear-gradient(135deg, rgba(87, 96, 111, 0.3), rgba(87, 96, 111, 0.1))',    // Gris
                'linear-gradient(135deg, rgba(75, 123, 236, 0.3), rgba(75, 123, 236, 0.1))',  // Bleu
                'linear-gradient(135deg, rgba(232, 65, 24, 0.3), rgba(232, 65, 24, 0.1))',    // Rouge
                'linear-gradient(135deg, rgba(156, 136, 255, 0.3), rgba(156, 136, 255, 0.1))', // Violet
              ];

              // Sélectionner un dégradé en fonction de l'index
              const gradient = gradients[index % gradients.length];
              const isActive = selectedService === service.nom_service;
              return (
                <div
                  key={service.id}
                  onClick={() => handleServiceSelect(service)}
                  className={`bg-white rounded-xl shadow-sm cursor-pointer transition-all duration-300 p-3 ${isActive ? '!bg-[#066AC91A] !text-[#066AC9]' : ''
                    }`} 
                  >
                  <div
                    className="h-16 flex justify-center items-center mb-3 rounded-lg overflow-hidden"
                    style={{ background: gradient }}
                  >
                    <img
                      src={`${apiUrlImg}/${service.image}`}
                      alt={service.nom_service}
                      className="w-12 h-12 object-cover"
                    />
                  </div>
                  <h3 className={`text-xs font-medium text-center text-gray-800 truncate ${isActive ? '!text-[#066AC9]' : ''}`}>
                    {service.nom_service}
                  </h3>
                </div>
              );
            })}

          </div>
        </div>
      )}

      <div className="w-[90%] flex flex-col items-center font-inter font-medium  mt-8">
        <h2 className="text-sm font-medium mb-3">Sous services</h2>
        {selectedService && (
          <div className="flex flex-wrap justify-center gap-2">
            {getSelectedServiceSousServices().map((sousService) => (
              <FilterButton
                key={sousService.id}
                label={sousService.nom_sous_service}
                onClick={handleSousServiceSelect}
                selected={sousService.nom_sous_service === selectedSousService}
              />
            ))}
          </div>
        )}
      </div>


      {!user && (
        <div
          className={`flex md:justify-end justify-center w-[89%] ${display}`}
        >
          <MonBouton
            children={"Rejoindre un projet"}
            couleurFond={"bg-orange"}
            bordure="border py-2 px-4 rounded-full text-base font-inter text-white gap-2 font-sans font-medium"
            action={() => navigate("projets")}
            type={"button"}
          />
        </div>
      )}

      <ProjectsList projects={filteredProjects} isLoading={isLoading} />
    </div>
  );
}

export default CategoriesProjects;
